import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from '@mui/material';
import { closeDialog } from '@/features/dialog/dialogSlice';
import { CompleteDealContent } from './CompleteDealContent';

export const CompleteDealDialog = () => {
	const dispatch = useDispatch();
	const dialogOpen = useSelector((state) => state.dialog.open.completeDeal);
	const [loading, setLoading] = useState(false);

	return (
		<Dialog
			open={dialogOpen}
			onClose={(_, reason) => {
				if (reason === 'backdropClick') {
					return false;
				} else if (!loading) {
					dispatch(closeDialog('completeDeal'));
				}
			}}
			hideBackdrop={true}
			fullWidth={true}
			maxWidth={'xl'}
			fullScreen={true}
			slotProps={{
				paper: {
					sx: { borderRadius: '16px' },
				},
			}}
			sx={{
				zIndex: (theme) => theme.zIndex.modal + 1,
				px: { xs: 0, sm: 4, md: '5vw', lg: '10vw' },
				py: { xs: 0, sm: 3 },
			}}
		>
			{dialogOpen && <CompleteDealContent {...{ loading, setLoading }} />}
		</Dialog>
	);
};
